export class ResetPasswordForm {
  public constructor(public readonly password: string) {}
}
